export const YM_COUNTERS = [112355440, 112993540];
const YM_SPA_COUNTER = 112993540;

export const reachGoal = (goal, params) => {
  if (typeof window === 'undefined' || !window.ym) return;
  YM_COUNTERS.forEach((id) => window.ym(id, 'reachGoal', goal, params));
};

let lastUrl = document.referrer;

// Счётчик 112993540 инициализирован с defer:true — все просмотры (включая первый) отправляются вручную.
export const trackPageView = () => {
  if (!window.ym) return;
  const url = window.location.href;
  window.ym(YM_SPA_COUNTER, 'hit', url, { title: document.title, referer: lastUrl });
  lastUrl = url;
};
